import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography, UtpCardModal } from 'common/components';

export const QualityAssurance: React.FC<UtpCardModal> = ({ elementBlock = '', onClick }) => (
  <>
    <ModalHeader title="Предоставим гарантию" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Мы&nbsp;отвечаем за&nbsp;качество наших изделий и&nbsp;даём гарантию до&nbsp;50&nbsp;лет на&nbsp;все
        материалы. Гарантия распространяется как на&nbsp;технические характеристики, так
        и&nbsp;на&nbsp;внешний вид товара. Точный срок гарантии на&nbsp;конкретный товар можно уточнить
        у&nbsp;нашего менеджера.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={elementBlock}
        elementName="Записаться на консультацию"
        elementText="Гарантия качества"
        onClick={onClick}
        wide>
        Записаться на консультацию
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
